// extracted by mini-css-extract-plugin
export default {"ProfileHeader":"ProfileHeader_ProfileHeader__iEfJT"};